var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"columns":_vm.historyColumns,"data":_vm.historyData}}),_c('Page',{staticClass:"paging",attrs:{"total":_vm.dataCount,"page-size":_vm.pageSize,"show-total":""},on:{"on-change":_vm.changepage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }